// extracted by mini-css-extract-plugin
export var container = "applyContent-module--container--dcee1";
export var emailTip = "applyContent-module--emailTip--301a5";
export var tip = "applyContent-module--tip--da164";